import { omit } from 'lodash';
import { useState } from 'react';
import { isReassignableOrderItem } from './constants';

const getSelectableItems = (items) =>
  (items || [])?.filter(isReassignableOrderItem);

const useNestedOrderItemSelection = () => {
  const [itemSelection, setItemSelection] = useState({});

  const selectedEntries = Object.values(itemSelection);
  const selectedOrders = selectedEntries?.map((entry) => entry?.order);
  const selectedOrderItems = selectedEntries?.flatMap(
    (entry) => entry?.items || [],
  );
  const hasItemSelection = selectedOrderItems?.length > 0;

  const clearItemSelection = () => setItemSelection({});

  const getNestedRowSelection = (order, items) => {
    const selectableItems = getSelectableItems(items);

    return {
      selectedRowKeys:
        itemSelection?.[order?.id]?.items?.map((item) => item?.id) || [],
      onChange: (keys) =>
        setItemSelection((prev) =>
          keys?.length
            ? {
                ...prev,
                [order?.id]: {
                  order,
                  items: selectableItems?.filter((item) =>
                    keys?.includes(item?.id),
                  ),
                },
              }
            : omit(prev, [order?.id]),
        ),
      getCheckboxProps: (item) => ({
        disabled: !isReassignableOrderItem(item),
      }),
    };
  };

  const getSelectedOrderItems = async () => selectedOrderItems;

  return {
    selectedOrders,
    hasItemSelection,
    clearItemSelection,
    getNestedRowSelection,
    getSelectedOrderItems,
  };
};

export default useNestedOrderItemSelection;
